<template>
  <div><slot></slot></div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import { EventBus } from '../helpers/bus';
import BaseComponent from './Base';

@Component({
  name: 'swiper-slide',
})
export default class SwiperSlide extends BaseComponent {
  protected isVisibleBeforeChange: boolean = false;

  protected isActiveSlide(): boolean {
    return this.$el.classList.contains('swiper-slide-active');
  }

  protected mounted(): void {
    this.isVisibleBeforeChange = this.isActiveSlide();
    (this.$parent as BaseComponent).$on('slideChange', () => this.isVisibleBeforeChange = this.isActiveSlide());
    (this.$parent as BaseComponent).$on('slideChangeTransitionEnd', () => {
      if (!this.isActiveSlide() && this.isVisibleBeforeChange) {
        this.isVisibleBeforeChange = false;
        EventBus.$emit(`slideHidden:${this.uniqId}`);
      }
    });
  }
}
</script>
